var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCriteria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 10.8H13.2V2.40002H10.8V10.8H2.39999V13.2H10.8V21.6H13.2V13.2H21.6V10.8Z",
    fill: "#ABA7AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCriteria);
export default __webpack_public_path__ + "static/media/AddCriteria.e78d935e8442333ed577d71a8bec006b.svg";
export { ForwardRef as ReactComponent };